import { render, staticRenderFns } from "./AccountChangeActivationType.vue?vue&type=template&id=4a2f6060&"
import script from "./AccountChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./AccountChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports